export default "__VITE_ASSET__85ee48ed__"